<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :submit="CSubmit"
        size="xl"
        :rules="CRuleAddOder"
        :title="$t('labels.orderEdit')"
        @close="close">
        <div :style="{ minWidth: minWidthScroll }">
            <hts-card
                v-if="dataAdd.createOrderFrom === 'QUOTE' || (dataAdd.createOrderFrom === 'CUSTOMER_REQUEST' && customerRequestPages === 1)"
                :loading="loading"
                :title="$t('labels.generalInformation')">
                <hts-form-radio
                    v-model="dataAdd.createOrderFrom"
                    label-key="label"
                    value-key="value"
                    :items="listOrderFrom"
                    disabled
                    class="pb-5"
                    name="createOrderFrom"
                    prop="createOrderFrom" />

                <div v-if="dataAdd.createOrderFrom === 'QUOTE' || (dataAdd.createOrderFrom === 'CUSTOMER_REQUEST' && customerRequestPages === 1)">
                    <div class="grid gap-x-2 grid-cols-4">
                        <hts-select-cooperator
                            v-model="dataAdd.customer"
                            v-model:name="dataAdd.customerName"
                            :label="$t('labels.customer')"
                            type-cooperator="CUSTOMER"
                            :creatable="true"
                            required
                            disabled
                            prop="customer"
                            name-select="customer" />
                        <hts-select-cooperator-contact
                            v-model="dataAdd.contact"
                            v-model:name="dataAdd.contactName"
                            :disabled="!dataAdd.customer"
                            :cooperator-id="dataAdd.customer"
                            :label="$t('labels.businessContact')"
                            :creatable="true"
                            required
                            prop="businessContact"
                            type="BUSINESS"
                            name-select="businessContact"
                            :param-prepare="dataAdd.customer"
                            @change="selectContact" />
                        <hts-form-input
                            v-model="dataContact.email"
                            :label="$t('labels.email')"
                            disabled
                            required />
                        <hts-form-input
                            v-model="dataContact.phone"
                            :label="$t('labels.phone')"
                            disabled
                            required />
                    </div>

                    <!-- Liên hệ logistic -->
                    <div class="grid gap-x-2 grid-cols-4">
                        <div />
                        <hts-select-cooperator-contact
                            v-model="dataAdd.logisticContact"
                            v-model:name="dataAdd.logisticContactName"
                            :disabled="!dataAdd.customer"
                            :cooperator-id="dataAdd.customer"
                            :label="$t('labels.logisticContact')"
                            :creatable="true"
                            required
                            prop="logisticContact"
                            name-select="logisticContact"
                            type="LOGISTIC"
                            key-sub-label="warehouseNames"
                            :param-prepare="dataAdd.customer"
                            @change="selectLogisticContact" />
                        <hts-form-input
                            v-model="dataLogisticContact.email"
                            :label="$t('labels.email')"
                            disabled
                            required />
                        <hts-form-input
                            v-model="dataLogisticContact.phone"
                            :label="$t('labels.phone')"
                            disabled
                            required />
                    </div>
                </div>

                <div
                    v-if="dataAdd.createOrderFrom === 'QUOTE'"
                    class="grid gap-2 grid-cols-2">
                    <hts-form-select
                        v-model="dataAdd.idQuoteAndCharge"
                        v-model:text="dataAdd.quoteName"
                        :items="quoteLists"
                        :filterable="true"
                        :clearable="true"
                        :label="$t('labels.quote')"
                        disabled
                        name="quote"
                        prop="quote"
                        required
                        key-id="idQuoteAndCharge"
                        key-label="quoteAndRouteName"
                        key-sub-label="goodsPropertiesName" />

                    <hts-select-commodity-opportunity
                        v-model="dataAdd.commodity"
                        v-model:name="dataAdd.commodityName"
                        :label="$t('labels.commodity')"
                        :creatable="true"
                        :disabled="!dataAdd.businessOpportunity"
                        :cooperator-id="dataAdd.customer"
                        :opportunity-id="dataAdd.businessOpportunity"
                        prop="commodity"
                        name-select="commodity"
                        :param-prepare="dataAdd.businessOpportunity" />

                    <hts-form-input
                        v-model="dataAdd.noBooking"
                        class="col-span-2"
                        :label="$t('labels.noBooking')" />
                </div>

                <div v-if="customerRequestPages === 1 && dataAdd.createOrderFrom === 'CUSTOMER_REQUEST'">
                    <div class="grid gap-x-2 grid-cols-2">
                        <hts-select-cooperator-business-opportunity
                            v-model="dataAddByCustomerRequest.businessOpportunity"
                            v-model:name="dataAddByCustomerRequest.businessOpportunityName"
                            :label="$t('labels.businessOpportunity')"
                            :creatable="true"
                            :disabled="disabledChangeBusinessOpportunity"
                            :cooperator-id="dataAdd.customer"
                            required
                            prop="businessOpportunity"
                            name-select="businessOpportunity"
                            key-label="nameCustom1"
                            key-sub-label="nameCustom2"
                            :param-prepare="dataAdd.customer"
                            @change="selectCooperatorBusinessOpportunity" />

                        <hts-select-commodity-opportunity
                            v-model="dataAddByCustomerRequest.commodity"
                            v-model:name="dataAddByCustomerRequest.commodityName"
                            :label="$t('labels.commodity')"
                            :creatable="true"
                            :disabled="!dataAdd.customer || !dataAddByCustomerRequest.businessOpportunity || viewShippingPlan"
                            :cooperator-id="dataAdd.customer"
                            :opportunity-id="dataAddByCustomerRequest.businessOpportunity"
                            required
                            prop="commodity"
                            name-select="commodity"
                            :param-prepare="dataAddByCustomerRequest.businessOpportunity" />
                    </div>

                    <div class="flex gap-2">
                        <hts-form-input
                            v-if="dataAddByCustomerRequest.truckOrderCode"
                            v-model="dataAddByCustomerRequest.truckOrderCode"
                            label="Truck Order"
                            readonly
                            class="w-full" />

                        <hts-form-input
                            v-if="dataAddByCustomerRequest.containerCode"
                            v-model="dataAddByCustomerRequest.containerCode"
                            :label="$t('labels.container')"
                            readonly
                            class="w-full" />
                    </div>

                    <hts-form-input
                        v-model="dataAddByCustomerRequest.workflowName"
                        :label="$t('labels.workflow')"
                        disabled
                        required
                        :param-prepare="dataAddByCustomerRequest.businessOpportunity" />
                    <ul
                        v-if="dataAddByCustomerRequest.positions && dataAddByCustomerRequest.positions.length"
                        class="steps steps-vertical w-full">
                        <li
                            v-for="(item, index) in dataAddByCustomerRequest.positions"
                            :key="index"
                            data-content=" "
                            class="pl-10 step w-full">
                            <div class="flex items-center justify-center w-full">
                                <span class="w-52 flex justify-start">
                                    {{ item.nodeTypeName }}
                                </span>
                                <div class="flex items-center w-full gap-5">
                                    <hts-form-input
                                        v-model="item.fullNameNode"
                                        class="w-full"
                                        readonly />

                                    <hts-form-button
                                        icon-name="hi-eye-icon"
                                        size="small"
                                        class="w-96"
                                        color="info"
                                        :outline="false"
                                        @click="() => openWorkflowPosition(item)">
                                        {{ $t('labels.viewTaskInfo') }}
                                    </hts-form-button>
                                </div>
                            </div>
                        </li>
                        <!--
                          <div class="text-right">
                          <span
                          class="right-20 text-lg text-blue-600 cursor-pointer italic"
                          @click="openWithMap">
                          {{ $t('labels.openWithMap') }}
                          </span>
                          </div>
                        -->
                    </ul>
                    <div>
                        <hts-form-input
                            v-model="dataAddByCustomerRequest.noBooking"
                            :label="$t('labels.noBooking')" />

                        <div v-if="dataAddByCustomerRequest.transportation === 'CONTAINER'">
                            <hts-form-input
                                v-model="dataAddByCustomerRequest.contName"
                                :label="$t('labels.cont')"
                                readonly
                                required
                                class="mb-2" />
                            <span>
                                {{ $t('labels.requestSpecial') }}
                                <span class="text-error-500">
                                    *
                                </span>
                            </span>
                            <div class="flex">
                                <hts-form-checkbox
                                    v-if="dataAddByCustomerRequest?.contCategory && Number(dataAddByCustomerRequest.contCategory) === 20"
                                    v-model="dataAddByCustomerRequest.mergeContainer"
                                    color="secondary"
                                    :disabled="viewShippingPlan"
                                    :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                                <hts-form-checkbox
                                    v-model="dataAddByCustomerRequest.headContainer"
                                    color="secondary"
                                    required
                                    :disabled="viewShippingPlan"
                                    :items="[{ label: $t('labels.headContainer'), value: false }]" />
                            </div>
                        </div>
                        <div v-else-if="dataAddByCustomerRequest.transportation === 'NON_CONTAINER'">
                            <hts-form-input
                                v-model="dataAddByCustomerRequest.vehicleCategoryName"
                                :label="$t('labels.vehicleType')"
                                readonly
                                required />
                        </div>
                        <hts-form-input
                            v-model="dataAddByCustomerRequest.productivity"
                            :label="$t('labels.productivityByMount')"
                            type="number"
                            required
                            :disabled="viewShippingPlan">
                            <template #suffix>
                                <span>
                                    {{ dataAddByCustomerRequest.transportation ? (dataAdd.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                </span>
                            </template>
                        </hts-form-input>
                        <hts-form-input
                            v-model="dataAddByCustomerRequest.weightCommodity"
                            :label="$t('labels.weightCommodityByKG1')"
                            type="number"
                            required
                            :disabled="viewShippingPlan"
                            prop="weightCommodityByKG"
                            name="weightCommodityByKG1">
                            <template #suffix>
                                <span>
                                    {{
                                        dataAddByCustomerRequest.transportation
                                            ? dataAddByCustomerRequest.transportation === 'CONTAINER'
                                                ? $t('labels.cont')
                                                : $t('labels.vehicle')
                                            : '-'
                                    }}
                                </span>
                            </template>
                        </hts-form-input>
                    </div>
                </div>

                <div
                    v-if="dataAdd.createOrderFrom === 'QUOTE' || customerRequestPages === 1"
                    :title="$t('labels.generalInformation')">
                    <hts-form-checkbox
                        v-if="numberWarehouseNode"
                        v-model="dataAdd.workingTimeRequest"
                        :label="$t('labels.requireWorkingTimeWarehouse')"
                        :items="listWorkingTimeRequest"
                        :disabled="viewShippingPlan" />

                    <hts-form-input
                        v-model="dataAdd.productivityOrder"
                        required
                        type="number"
                        prop="productivityOrder"
                        name="productivityOrder"
                        :label="$t('labels.productivityOrder')">
                        <template #suffix>
                            <div class="w-10 text-center">
                                <p v-if="dataAdd.createOrderFrom === 'QUOTE'">
                                    {{ dataAdd?.transportation === 'NON_CONTAINER' ? $t('labels.vehicle') : dataAdd?.transportation === 'CONTAINER' ? $t('labels.cont') : '-' }}
                                </p>
                                <p v-else>
                                    {{
                                        dataAddByCustomerRequest?.transportation === 'NON_CONTAINER'
                                            ? $t('labels.vehicle')
                                            : dataAddByCustomerRequest?.transportation === 'CONTAINER'
                                                ? $t('labels.cont')
                                                : '-'
                                    }}
                                </p>
                            </div>
                        </template>
                    </hts-form-input>
                </div>

                <hts-form-textarea
                    v-if="dataAdd.createOrderFrom === 'QUOTE' || (dataAdd.createOrderFrom === 'CUSTOMER_REQUEST' && customerRequestPages === 1)"
                    v-model="dataAdd.request"
                    :label="$t('labels.note')" />
            </hts-card>

            <hts-card
                v-if="
                    (dataAdd?.quote && dataAdd.createOrderFrom === 'QUOTE') ||
                        (dataAdd.createOrderFrom === 'CUSTOMER_REQUEST' && customerRequestPages === 2 && dataAddByCustomerRequest.positions)
                "
                :loading="loading">
                <template #title>
                    <div class="w-full flex justify-start gap-4 my-2">
                        <span>
                            {{ $t('labels.shippingInformation2') }}
                        </span>
                        <hi-pencil-square-icon
                            v-if="viewShippingPlan || typeSolutionWaitingTimeTaskSelected === 'manualPlanning'"
                            class="w-6 h-6 text-error-500 cursor-pointer"
                            @click="handleEditShippingPlan" />

                        <hi-puzzle-piece-icon
                            v-if="solutionWaitingTimeTask && solutionWaitingTimeTask.length"
                            class="w-6 h-6 text-info-500 cursor-pointer"
                            @click="quickShowModalSolutionWaitingTimeTask" />

                        <div class="flex flex-col border-2 border-dotted pl-2 pb-2 pr-2">
                            <span class="font-normal text-lg text-warning-600">
                                Ghi chú
                            </span>
                            <div class="flex justify-start gap-4 my-2">
                                <div class="flex justify-start gap-4 my-2 items-center">
                                    <date-time
                                        class="w-[90px] min-w-[90px]"
                                        readonly
                                        color="success" />
                                    <span class="font-normal text-lg">
                                        {{ $t('labels.earliestDeadline') }}
                                    </span>
                                </div>
                                <div class="flex justify-start gap-4 my-2 items-center">
                                    <date-time
                                        class="w-[90px] min-w-[90px]"
                                        readonly
                                        color="warning" />
                                    <span class="font-normal text-lg">
                                        {{ $t('labels.latestDeadline') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>

                <shipping-information
                    v-if="dataAdd.createOrderFrom === 'QUOTE'"
                    key="dataAdd.positions"
                    :positions="dataAdd.positions"
                    :condition="dataAdd.condition"
                    :waiting-tasks="dataAdd.waitingTasks"
                    :edit-travel-time="CEditTravelTime"
                    :disabled="CDisabledEditCompletionTime" />

                <shipping-information
                    v-else
                    key="dataAddByCustomerRequest.positions"
                    :positions="dataAddByCustomerRequest.positions"
                    :condition="dataAdd.condition"
                    :waiting-tasks="dataAdd.waitingTasks"
                    :edit-travel-time="CEditTravelTime"
                    :disabled="CDisabledEditCompletionTime" />

                <div
                    v-if="typeSolutionWaitingTimeTaskSelected === 'manualPlanning'"
                    class="grid grid-cols-3 gap-3">
                    <hts-form-date
                        v-model="manualPlanning.IN"
                        :label="`Thời gian in điểm ${CPositions?.[0]?.nodeLocationName} (vị trí 1)`"
                        class="w-full"
                        type="datetime"
                        time-format="HH:mm"
                        required
                        :unix-time="true" />

                    <!--
                      <hts-form-date
                      v-model="manualPlanning.OUT"
                      :label="`Thời gian out điểm ${CPositions?.[CPositions.length - 1]?.nodeLocationName} (vị trí ${CPositions.length})`"
                      class="w-full"
                      type="datetime"
                      time-format="HH:mm"
                      required
                      :disabled="viewShippingPlan"
                      />
                    -->
                </div>

                <div class="flex justify-start gap-2">
                    <hts-form-button
                        color="info"
                        type="button"
                        :outline="false"
                        :loading="loadShippingPlan"
                        :disabled="viewShippingPlan || typeSolutionWaitingTimeTaskSelected === 'manualPlanning'"
                        @click="handleShowShippingPlan">
                        {{ $t('labels.watchOrderPlan') }}
                    </hts-form-button>

                    <hts-tooltip
                        placement="top"
                        :offset="[5, 5]">
                        <div>
                            <p>
                                {{ $t('labels.taskSettingLabel') }}
                            </p>
                        </div>
                        <template #reference>
                            <hts-form-button
                                color="error"
                                type="button"
                                :outline="false"
                                @click="openConditionSetting">
                                {{ $t('labels.taskSetting') }}
                            </hts-form-button>
                        </template>
                    </hts-tooltip>

                    <hts-form-button
                        color="accent"
                        type="button"
                        :outline="false"
                        :disabled="CDisabledEditCompletionTime"
                        @click="openWaitingTask">
                        <span class="text-white">
                            {{ $t('labels.addWaitingTask') }}
                        </span>
                    </hts-form-button>
                </div>
            </hts-card>

            <workflow-position
                ref="workflowPosition"
                v-loading="loading"
                disabled
                @update="updatePosition" />

            <view-position
                ref="viewPosition"
                :edit="false"
                disabled />

            <travel-detail
                ref="travelDetail"
                :find-route="findRoute"
                :allocation-status="allocationStatus"
                @updateRoute="handleUpdateRoute" />

            <shipping-plan
                ref="shippingPlan"
                v-loading="loading" />
        </div>

        <template
            v-if="dataAdd.createOrderFrom === 'CUSTOMER_REQUEST'"
            #footer>
            <div
                v-loading="loading"
                class="flex flex-row justify-between w-full gap-5">
                <hts-form-button
                    icon-name="hi-arrow-left-icon"
                    icon-position="right"
                    type="button"
                    :outline="false"
                    :disabled="customerRequestPages === 1 || viewShippingPlan"
                    @click="changeCustomerRequestPages(customerRequestPages - 1)">
                    {{ $t('labels.back') }}
                </hts-form-button>

                <hts-form-button
                    v-if="customerRequestPages < 2"
                    icon-name="hi-arrow-right-icon"
                    icon-position="right"
                    color="primary"
                    :outline="false"
                    type="submit">
                    {{ $t('labels.next') }}
                </hts-form-button>
                <hts-form-button
                    v-if="customerRequestPages === 2"
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    :outline="false"
                    type="submit">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </div>
        </template>

        <hts-modal
            :show="showModalSolutionWaitingTimeTask && numberOfViolations !== 1"
            title="Điều chỉnh thông tin vận chuyển"
            @hide="closeSolutionWaitingTimeTask">
            <div class="mt-5">
                <p>
                    Đơn hàng đang vi phạm nguyên tắc vận chuyển. Bạn phải điều chỉnh thông tin vận chuyển hoặc lên kế hoạch thủ công
                </p>
                <h4>
                    Vui lòng chọn giải pháp bên dưới
                </h4>

                <hts-form-radio
                    v-model="typeSolutionWaitingTimeTaskSelectedTmp"
                    class="w-full"
                    value-key="key"
                    label-key="solutionText"
                    type="list"
                    :items="solutionWaitingTimeTask" />
            </div>

            <div class="flex justify-end mt-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="button"
                    :outline="false"
                    @click="confirmSolutionWaitingTimeTask">
                    {{ $t('labels.save') }}
                </hts-form-button>
            </div>
        </hts-modal>

        <hts-modal
            :show="showModalSolutionWaitingTimeTask && numberOfViolations === 1"
            title="Điều chỉnh thông tin vận chuyển"
            @hide="resetViolations">
            <div class="mt-5">
                <p>
                    Đơn hàng đang vi phạm nguyên tắc vận chuyển. Vui lòng kiểm tra lại các thời hạn đã đúng theo thông tin booking hoặc thực hiện điều chỉnh thời gian di
                    chuyển/thời gian hoàn thành tác vụ.
                </p>
            </div>

            <div class="flex justify-end mt-5">
                <hts-form-button
                    icon-position="right"
                    color="primary"
                    type="button"
                    :outline="false"
                    @click="resetViolations">
                    Kiểm tra thời hạn
                </hts-form-button>

                <hts-form-button
                    icon-position="right"
                    color="primary"
                    type="button"
                    :outline="false"
                    @click="confirmSolutionWaitingTimeTask">
                    Điều chỉnh thời gian
                </hts-form-button>
            </div>
        </hts-modal>

        <hts-modal
            :show="manyPermanent"
            @hide="manyPermanent = false">
            <div>
                <p>
                    Không thể tối ưu thời gian chờ do tại điểm có nhiều hơn 1 cố định
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showViolatesPrinciples"
            @hide="showViolatesPrinciples = false">
            <div>
                <p>
                    Đơn hàng đang vi phạm nguyên tắc vận chuyển
                </p>
                <p>
                    Bạn nên điều chỉnh thông tin vận chuyển hoặc tiếp tục lưu thông tin vi phạm
                </p>
            </div>

            <div class="flex justify-end mt-5 gap-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    type="button"
                    :outline="false"
                    @click="handleSubmitViolatesPrinciples">
                    {{ $t('labels.save') }}
                </hts-form-button>

                <hts-form-button
                    icon-name="hi-pencil-icon"
                    icon-position="right"
                    color="primary"
                    type="button"
                    :outline="false"
                    @click="handleAdjustShippingInformation">
                    {{ $t('labels.adjust') }}
                </hts-form-button>
            </div>
        </hts-modal>

        <hts-modal
            :show="showWarningHolidayWorking"
            type="confirm"
            :confirm-label="$t('labels.continue')"
            @hide="() => actionCancelTimeWorking()"
            @confirm="() => actionConfirmTimeWorking()">
            <div>
                <p>
                    {{ contentWarningHolidayWorking }}
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showWarningOverTimeWorking"
            type="confirm"
            :confirm-label="$t('labels.continue')"
            @hide="() => actionCancelTimeWorking()"
            @confirm="() => actionConfirmTimeWorking()">
            <div>
                <p>
                    {{ contentWarningOverTimeWorking }}
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showConfirmEditShippingPlan"
            type="confirm"
            @hide="showConfirmEditShippingPlan = false"
            @confirm="handleCloseShippingPlan(true)">
            <div>
                <p>
                    {{ $t('labels.confirmEditShippingPlan') }}
                </p>
            </div>
        </hts-modal>

        <hts-modal
            :show="showModalNotFoundRoute || showModalConfirmSaveNotFoundRoute"
            @hide="
                () => {
                    showModalNotFoundRoute = false
                    showModalConfirmSaveNotFoundRoute = false
                }
            ">
            <div>
                <p class="mt-5">
                    Hệ thống không thể tính toán kế hoạch vận chuyển do thiếu thông tin tuyến đường. Vui lòng liên hệ Điều độ để thực hiện vẽ tuyến.
                </p>

                <div
                    v-if="showModalConfirmSaveNotFoundRoute"
                    class="flex justify-end mt-5 gap-5">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        type="button"
                        :outline="false"
                        @click="handleSubmitNotFoundRoute">
                        {{ $t('labels.save') }}
                    </hts-form-button>
                </div>
            </div>
        </hts-modal>

        <hts-modal
            :show="showWarningRouteGGMap"
            type="confirm"
            :hide-close="true"
            :auto-close="true"
            @confirm="() => handleShowShippingPlan({ confirmRouteGGMap: true })"
            @hide="handleRejectRouteGGMap">
            <div>
                <p class="mt-5">
                    {{ CWarningRouteGGMap }}
                </p>
            </div>
        </hts-modal>

        <condition-setting
            ref="conditionSetting"
            @update="(val) => updateConditionSetting(val)" />
        <waiting-task
            ref="waitingTask"
            @update="(val: any) => updateWaitingTask(val)" />
    </hts-drawer>
</template>

<script setup lang="ts">
import ViewPosition from '../../quote/quote-request/-components/view-position.vue'
import WorkflowPosition from '../../quote/quote-request/-components/workflow-position.vue'
import DateTime from './component/date-time.vue'
import ConditionSetting from './condition-setting.vue'
import data from './imports/data'
import form from './imports/form'
import Direction from './plugins/direction'
import ShippingInformation from './shipping-information.vue'
import ShippingPlan from './shipping-plan.vue'
import TravelDetail from './travel-detail.vue'
import WaitingTask from './waiting-task.vue'

import { $api, $url } from '#imports'

import screen from '~/components/utils/screen'

const { map: mapStore } = $store()
const { listOrderFrom, listWorkingTimeRequest } = data()

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 50}px`
})

const emits = defineEmits(['refreshTables'])

const orderId = ref('')
const allocationStatus = ref(0)

const {
  visible,
  updateNode,
  dataAdd,
  dataAddByCustomerRequest,
  viewShippingPlan,
  dataContact,
  dataLogisticContact,
  shippingPlan,
  workflowPosition,
  customerRequestPages,
  loadShippingPlan,
  numberWarehouseNode,
  solutionWaitingTimeTask,
  showModalSolutionWaitingTimeTask,
  typeSolutionWaitingTimeTaskSelected,
  typeSolutionWaitingTimeTaskSelectedTmp,
  optimizeWaitingTime,
  manyPermanent,
  violatesPrinciples,
  showViolatesPrinciples,
  conditionSetting,
  waitingTask,
  manualPlanning,
  numberOfViolations,
  showConfirmEditShippingPlan,
  contentWarningHolidayWorking,
  contentWarningOverTimeWorking,
  showWarningHolidayWorking,
  showWarningOverTimeWorking,
  actionCancelTimeWorking,
  actionConfirmTimeWorking,
  quoteLists,
  CEditTravelTime,
  CPositions,
  CDisabledEditCompletionTime,
  openWorkflowPosition,
  close,
  resetWarehouseNode,
  resetNumberOfViolations,
  handleShowShippingPlan,
  handleEditShippingPlan,
  handleCloseShippingPlan,
  openConditionSetting,
  updateConditionSetting,
  openWaitingTask,
  updateWaitingTask,
  selectContact,
  selectLogisticContact,
  confirmSolutionWaitingTimeTask,
  resetViolations,
  CConfigCont,
  CConfigVehicle,
  viewPosition,
  openWithMap,
  closeSolutionWaitingTimeTask,
  updatePosition,
  changeCustomerRequestPages,
  listLabelCont,
  updateWarningTimeWorking,
  handleGetQuoteByCustomerRequest,
  handleAdjustShippingInformation,
  quickShowModalSolutionWaitingTimeTask,
  loading,
  travelDetail,
  getNodeData,
  notFoundRoute,
  showModalNotFoundRoute,
  showModalConfirmSaveNotFoundRoute,
  CWarningRouteGGMap,
  showWarningRouteGGMap,
  findRoute,
  handleUpdateRoute,
  handleRejectRouteGGMap,
  routeGGMap,
  disabledChangeBusinessOpportunity,
  selectCooperatorBusinessOpportunity
} = Direction()

const open = async (id: string) => {
  mapStore.setShowLocation({ order: false })

  visible.value = true
  orderId.value = id

  loading.value = true

  await nextTick(async () => {
    await getData(id)
    await getCustomer(dataAdd.value.customer)
    updateNode.value = false
    loading.value = false
  })
}

const getData = async (id: string) => {
  const api = $url.order.order.detail
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data.data.value
  disabledChangeBusinessOpportunity.value = true
  changeBusinessOpportunity.value = false

  if (resData?.success) {
    if (!resData.data.routingPositions) {
      notFoundRoute.value = true
    } else {
      notFoundRoute.value = false
    }
    routeGGMap.value = false

    allocationStatus.value = resData.data.allocationStatus

    if (resData.data.createOrderFrom === 'QUOTE') {
      dataAdd.value = resData.data
      dataAdd.value.quoteName = resData.data.quoteAndRouteName

      await getNodeData()
      await updateWarningTimeWorking(dataAdd.value.positions)

      if (typeSolutionWaitingTimeTaskSelected.value !== 'manualPlanning') {
        const { shippingPlanStatus } = resData.data

        setTimeout(() => {
          if (shippingPlanStatus === 200 || shippingPlanStatus === 202) {
            if (shippingPlan?.value) {
              shippingPlan.value.show(dataAdd.value.positions, dataAdd.value)
            }
            viewShippingPlan.value = true
          }

          if (shippingPlanStatus === 200) {
            if (travelDetail.value) {
              travelDetail.value.show(resData.data)
            }
          }
        }, 1000)
      }
    }

    if (resData.data.createOrderFrom === 'CUSTOMER_REQUEST') {
      dataAddByCustomerRequest.value = resData.data
      await getNodeData()
      updateWarningTimeWorking(dataAddByCustomerRequest.value.positions)
      if (resData.data.transportation && resData.data.transportation === 'CONTAINER') {
        dataAddByCustomerRequest.value.contName = listLabelCont[resData.data.contCategory] ?? ''
      }

      dataAdd.value.customer = resData.data.customer
      dataAdd.value.customerName = resData.data.customerName
      dataAdd.value.customerAbbreviationName = resData.data.customerAbbreviationName
      dataAdd.value.customerAddress = resData.data.customerAddress
      dataAdd.value.contact = resData.data.contact
      dataAdd.value.contactName = resData.data.contactName
      dataAdd.value.logisticContact = resData.data.logisticContact
      dataAdd.value.logisticContactName = resData.data.logisticContactName
      dataAdd.value.createOrderFrom = resData.data.createOrderFrom
      dataAdd.value.productivityOrder = resData.data.productivityOrder
      dataAdd.value.workingTimeRequest = resData.data.workingTimeRequest
      dataAdd.value.condition = resData.data.condition || []
      dataAdd.value.waitingTasks = resData.data.waitingTasks || []
      notResetFields.value = true

      if (!dataAddByCustomerRequest.value.businessOpportunity) {
        disabledChangeBusinessOpportunity.value = false
        changeBusinessOpportunity.value = true
      }
    }

    dataContact.value.phone = resData.data.contactPhone || ''
    dataContact.value.email = resData.data.contactEmail || ''

    dataLogisticContact.value.phone = resData.data.logisticContactPhone || ''
    dataLogisticContact.value.email = resData.data.logisticContactEmail || ''

    typeSolutionWaitingTimeTaskSelected.value = resData.data.solution || ''
    manualPlanning.value = resData.data.manualPlanning || {
      IN: null,
      OUT: null
    }

    viewShippingPlan.value = true
  }
}

const getCustomer = async (id: string | null) => {
  if (!id) {
    return
  }

  const api = $url.partner['get-detail']
  const data: any = await $api(api, { uriParams: { ID: id } })
  const resData: any = data?.data?.value
  if (resData?.success) {
    dataAdd.value.customerName = resData.data.name
    dataAdd.value.customerAbbreviationName = resData.data.abbreviationName
  }
}

const notResetFields = ref(false)
const changeBusinessOpportunity = ref(false)
const resetFields = (withoutCreateOrderFrom?: boolean) => {
  if (notResetFields.value) {
    notResetFields.value = false
    return
  }

  dataAdd.value = { ...form.initDataAddOrder }

  dataAddByCustomerRequest.value = { ...form.initDataAddOrderByCustomerRequest }
  dataAddByCustomerRequest.value.positions = []
  dataContact.value.phone = ''
  dataContact.value.email = ''
  viewShippingPlan.value = false
  customerRequestPages.value = 1
  changeBusinessOpportunity.value = false

  if (shippingPlan.value) {
    shippingPlan.value.close()
  }

  typeSolutionWaitingTimeTaskSelected.value = ''
  typeSolutionWaitingTimeTaskSelectedTmp.value = ''
  manualPlanning.value = {
    IN: null,
    OUT: null
  }

  violatesPrinciples.value = false
  showViolatesPrinciples.value = false
  solutionWaitingTimeTask.value = []
  loadShippingPlan.value = false
  resetWarehouseNode()
  resetNumberOfViolations()
}

const CSubmit = async () => {
  if (
    dataAdd.value.allotted &&
    dataAdd.value.productivityOrder &&
    dataAdd.value.productivityOrder > 0 &&
    dataAdd.value.productivityOrder < dataAdd.value.allotted
  ) {
    // process.client && $toast().error(' Tổng sản lượng của đơn hàng phải lớn hơn hoặc bằng sản lượng phân bổ thành công. Vui lòng điều chỉnh sản lượng của đơn hàng')

    return () => {}
  }

  if (dataAdd.value.createOrderFrom === 'QUOTE') {
    if (notFoundRoute.value) {
      showModalConfirmSaveNotFoundRoute.value = true
      return
    }
    await handleSubmitFormEdit()
    return
  }

  if (dataAdd.value.createOrderFrom === 'CUSTOMER_REQUEST') {
    if (customerRequestPages.value === 1) {
      await nextPage()
      return
    }

    if (customerRequestPages.value === 2) {
      if (notFoundRoute.value) {
        showModalConfirmSaveNotFoundRoute.value = true
        return
      }
      await handleSubmitFormEdit()
      return
    }
  }

  return () => {}
}

const handleSubmitViolatesPrinciples = async () => {
  violatesPrinciples.value = true
  showViolatesPrinciples.value = false
  await handleSubmitFormEdit()
}

const handleSubmitNotFoundRoute = async () => {
  showModalConfirmSaveNotFoundRoute.value = false
  await handleSubmitFormEdit()
}

const handleSubmitFormEdit = async () => {
  const api = $url.order.order.update
  dataAdd.value.quoteData = {}
  dataAddByCustomerRequest.value.quoteData = {}

  const dataBody: { [key: string]: any } =
    dataAdd.value.createOrderFrom === 'QUOTE'
      ? {
        ...dataAdd.value,
        violatesPrinciples: violatesPrinciples.value,
        solution: typeSolutionWaitingTimeTaskSelected.value,
        manualPlanning: manualPlanning.value,
        contactEmail: dataContact.value.email,
        contactPhone: dataContact.value.phone,
        logisticContactEmail: dataLogisticContact.value.email,
        logisticContactPhone: dataLogisticContact.value.phone
      }
      : {
        ...dataAddByCustomerRequest.value,
        customer: dataAdd.value.customer,
        customerName: dataAdd.value.customerName,
        customerAbbreviationName: dataAdd.value.customerAbbreviationName,
        customerAddress: dataAdd.value.customerAddress,
        contact: dataAdd.value.contact,
        contactName: dataAdd.value.contactName,
        logisticContact: dataAdd.value.logisticContact,
        logisticContactName: dataAdd.value.logisticContactName,
        createOrderFrom: dataAdd.value.createOrderFrom,
        productivityOrder: dataAdd.value.productivityOrder,
        condition: dataAdd.value.condition || [],
        waitingTasks: dataAdd.value.waitingTasks || [],
        request: dataAdd.value.request,
        contactEmail: dataContact.value.email,
        contactPhone: dataContact.value.phone,
        logisticContactEmail: dataLogisticContact.value.email,
        logisticContactPhone: dataLogisticContact.value.phone,
        workingTimeRequest: dataAdd.value.workingTimeRequest,
        violatesPrinciples: violatesPrinciples.value,
        solution: typeSolutionWaitingTimeTaskSelected.value,
        manualPlanning: manualPlanning.value
      }

  dataBody.notFoundRoute = notFoundRoute.value
  const data: any = await $api(api, { uriParams: { ID: orderId.value }, body: dataBody })
  const resData = data?.data?.value
  if (resData?.success) {
    const result = resData.data

    if (result.code === 201) {
      if (!numberOfViolations.value || numberOfViolations.value === 1) {
        numberOfViolations.value = 1
        showModalSolutionWaitingTimeTask.value = true
        return
      }

      numberOfViolations.value++
      solutionWaitingTimeTask.value = result.solutions
      typeSolutionWaitingTimeTaskSelected.value = ''
      showViolatesPrinciples.value = true
      return
    }

    resetNumberOfViolations()
    process.client && $toast().success($t('labels.editSuccess'))
    emits('refreshTables')
    close()
  }
}

const nextPage = async () => {
  if (viewShippingPlan.value) {
    nextTick(() => {
      const { shippingPlanStatus } = dataAddByCustomerRequest.value

      setTimeout(() => {
        if (shippingPlanStatus === 200 || shippingPlanStatus === 202) {
          if (shippingPlan?.value) {
            shippingPlan.value.show(dataAddByCustomerRequest.value.positions, dataAddByCustomerRequest.value)
          }
          viewShippingPlan.value = true
        }

        if (shippingPlanStatus === 200) {
          if (travelDetail.value) {
            travelDetail.value.show(dataAddByCustomerRequest.value)
          }
        }
      }, 1000)

      // handleShowShippingPlan()
    })
  }

  if (customerRequestPages.value === 1) {
    if (!changeBusinessOpportunity.value) {
      customerRequestPages.value = customerRequestPages.value + 1 || 1
      return
    }

    const quoteByCustomerRequest = await handleGetQuoteByCustomerRequest()
    if (quoteByCustomerRequest) {
      const legs = {} as { [key: string]: any }
      ;(quoteByCustomerRequest?.routingPositions?.route?.legs || [])?.forEach((item: any) => {
        legs[`${item.startLocation}-${item.endLocation}`] = item
      })

      quoteByCustomerRequest.positions?.forEach((position: { [key: string]: any }, indexP: number) => {
        // const travelTimeToNextPosition = Object.keys(legs).length ? legs[`${position._id}-${quoteByCustomerRequest?.positions?.[indexP + 1]?._id}`] : null
        // quoteByCustomerRequest.positions[indexP].travelTimeToNextPosition = travelTimeToNextPosition
        if (Array.isArray(position.tasks) && position.tasks.length) {
          position.tasks?.forEach((task: { [key: string]: any }, indexT: number) => {
            if (Array.isArray(task.timeConditions) && task.timeConditions.length) {
              task.timeConditions?.forEach((timeCondition: { [key: string]: any }, indexTC: number) => {
                quoteByCustomerRequest.positions[indexP].tasks[indexT].timeConditions[indexTC].time = ''
                quoteByCustomerRequest.positions[indexP].travelTimeToNextPosition = dataAddByCustomerRequest.value.positions?.[indexP]?.travelTimeToNextPosition
              })
            }
          })
        }
      })

      quoteByCustomerRequest.routingPositions = dataAddByCustomerRequest.value.routingPositions
      quoteByCustomerRequest.noBooking = dataAddByCustomerRequest.value.noBooking

      dataAddByCustomerRequest.value = quoteByCustomerRequest

      if (quoteByCustomerRequest.transportation && quoteByCustomerRequest.transportation === 'CONTAINER') {
        dataAddByCustomerRequest.value.contName = listLabelCont[quoteByCustomerRequest.contCategory] ?? ''
      }

      customerRequestPages.value = customerRequestPages.value + 1 || 1
      viewShippingPlan.value = false
    }
  }
}

const CRuleAddOder = computed(() => {
  const rules = {} as { [key: string]: string }
  if (dataAdd.value.createOrderFrom === 'QUOTE') {
    rules.createOrderFrom = 'required'
    rules.quote = 'required'

    if (!dataAdd.value.allotted) {
      rules.productivityOrder = 'required|gt:0'
    } else {
      rules.productivityOrder = `required|validationCustom:${
        (dataAdd.value.productivityOrder || 0) >= dataAdd.value.allotted
      }--Tổng sản lượng của đơn hàng phải lớn hơn hoặc bằng sản lượng phân bổ thành công. Vui lòng điều chỉnh sản lượng của đơn hàng`
    }
  }

  if (dataAdd.value.createOrderFrom === 'CUSTOMER_REQUEST' && customerRequestPages.value === 1) {
    // if (!dataAdd.value.allotted) {
    rules.productivityOrder = 'required|gt:0'
    // } else {
    //   rules.productivityOrder = `required|validationCustom:${(dataAdd.value.productivity || 0) >= dataAdd.value.allotted}--Tổng sản lượng của đơn hàng phải lớn hơn hoặc bằng sản lượng phân bổ thành công. Vui lòng điều chỉnh sản lượng của đơn hàng`
    // }

    if (dataAddByCustomerRequest.value.transportation === 'CONTAINER' && dataAddByCustomerRequest.value.contCategory) {
      if (
        CConfigCont.value &&
        CConfigCont.value[dataAddByCustomerRequest.value.contCategory] &&
        CConfigCont.value[dataAddByCustomerRequest.value.contCategory].weightCargo
      ) {
        rules.weightCommodityByKG = `required|validationCustom:
      ${
          dataAddByCustomerRequest.value.weightCommodity &&
          dataAddByCustomerRequest.value.weightCommodity <= CConfigCont.value[dataAddByCustomerRequest.value.contCategory].weightCargo
        }--
      ${$t('labels.checkWeightContainer')} - ${CConfigCont.value[dataAddByCustomerRequest.value.contCategory].weightCargo}`
      }
    } else if (dataAddByCustomerRequest.value.transportation === 'NON_CONTAINER' && dataAddByCustomerRequest.value.vehicleCategory && CConfigVehicle.value) {
      const findVehicleCategory = CConfigVehicle.value.find((findVehicleCategory: { [key: string]: any }) => {
        return findVehicleCategory._id === dataAddByCustomerRequest.value.vehicleCategory
      })
      if (findVehicleCategory) {
        const min = Number(findVehicleCategory.from || 0)
        const max = Number(findVehicleCategory.to || 999999999999999)
        rules.weightCommodityByKG = `required|validationCustom:
      ${
          dataAddByCustomerRequest.value.weightCommodity &&
          min <= dataAddByCustomerRequest.value.weightCommodity &&
          dataAddByCustomerRequest.value.weightCommodity < max
        }--
      ${$t('labels.checkWeightVehicle')} (${min} <= ${$t('labels.weightCommodity')} < ${max})`
      }
    }
  }

  return rules
})

defineExpose({
  open,
  close,
  resetFields
})
</script>
